import React from 'react'
import PropTypes from 'prop-types'
import { handleErrors } from 'utils/form'

class Form extends React.Component {

	constructor(props) {
		super(props)

		this.state = {
			successMsg: null
		}
	}

	render () {
		const { error, handleSubmit, children, shouldShowSuccessMessage } = this.props
		const { successMsg } = this.state
		const handleSubmitDecorated = (data) => {
			handleSubmit(data)
				.then(() => {
					this.setState({ successMsg: 'Successfully updated!' })
					setTimeout(() => {
						this.setState({ successMsg: null })
					}, 2000)
				})
		}
		return <form onSubmit={shouldShowSuccessMessage ? handleSubmitDecorated : handleSubmit}>
			{children}
			{error && handleErrors(error) }
			{ !error && successMsg && <div className='text-success mt'>{successMsg}</div>}
		</form>
	}
}

Form.propTypes = {
	error: PropTypes.string,
	handleSubmit: PropTypes.func,
	children: PropTypes.node,
	shouldShowSuccessMessage: PropTypes.bool
}

export default Form







// WEBPACK FOOTER //
// ./src/components/Form.js